export { ReactComponent as BetRecordScrollerArrow } from './BetRecordScrollerArrow.svg';